module.exports = __webpack_public_path__ + "img/fraud@3x.17a75448.png";